// src/components/Navbar.js
import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./Navbar.css";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const links = [
    { path: "/", label: "Home" },
    { path: "/about", label: "About" },
    { path: "/analytics", label: "Analytics" },
    { path: "/projects", label: "Projects" },
    { path: "/contact", label: "Contact" },
  ];

  return (
    <nav className="navbar">
      <div className="navbar-container">
        {/* Logo */}
        <NavLink to="/" className="navbar-logo">
          <img src="/logo192.png" alt="Logo" />
        </NavLink>

        {/* Links */}
        <ul className={`navbar-links ${isOpen ? "active" : ""}`}>
          {links.map(({ path, label }) => (
            <li key={path}>
              <NavLink to={path} onClick={() => setIsOpen(false)}>
                {label}
              </NavLink>
            </li>
          ))}
        </ul>

        {/* Hamburger Toggle */}
        <button
          className={`navbar-toggle ${isOpen ? "open" : ""}`}
          onClick={() => setIsOpen(!isOpen)}
        >
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
